const setCountries = (state, countries) => state.countries = countries;

const setStates = (state, states) => state.states = states;

const setCities= (state, cities) => state.cities = cities;

let mutations = {
  setCountries,
  setStates,
  setCities
};

export default mutations;
